export enum ToastActions {
  add = 'add',
  remove = 'remove'
}

export type ToastAction = ToastActions.add | ToastActions.remove;

export enum ToastViews {
  searches = 'searches',
  vehicles = 'vehicles'
}

export type ToastView = ToastViews.searches | ToastViews.vehicles;
